module.exports = __webpack_public_path__ + "static/media/cd-pluriel.8dd77aa6.jpg";